// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  background-color: #282c34;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content:flex-start;
  font-size: calc(8px + 2vmin);
  color: white;
  max-width: 100%;
  min-height: 100vh;
  padding-left: 1vw;
  padding-right: 1vw;
}

.App h3 {
  margin-bottom: -1em;
}

.App-header {
  /* text-align: center; */
  background-color: #282c34;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: calc(8px + 2vmin);
  color: white;
  width: 100%;
  height: 8vh;
  border-bottom: 1px solid rgb(29, 29, 29);
}

@keyframes myAnimation{
  35%{
    transform: translateY(0);
   /* transform: rotateX(0deg); */
  }
  100%{
    transform: translateY(-90vh);
    display: none;
  }
}

.App-Modal{
    animation-name: myAnimation;
    animation-duration: 4000ms;
    animation-fill-mode: forwards;
}

.App-Modal {
  background-color: transparent;
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}


@keyframes myAnimationViz{
  50%{
    transform: translateY(0vh);
  }
  100%{
    transform: translateY(-90vh);
  }
}

.FirstViz {
  animation-name: myAnimationViz;
  animation-duration: 4000ms;
  animation-fill-mode: backwards;
  margin-bottom: 7vh;
}

.FirstViz img {
  max-width: 80%;
  max-height: 80%;
}

.SideBySide {
  display: flex;
  /* flex-direction: row; */
  justify-content: space-evenly;
  gap: 5vw;
  margin-bottom: 5vh;
}

.SideBySide img {
  width: 35vw;
  height: 40vh;
}

.TextBox {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.TextBox a {
  color: white;
  text-decoration: none;
  font-weight: bold;
}

.NotesBox a {
  color: white;
  text-decoration: none;
}

.App-header a {
  color: white;
  text-decoration: none;
  font-weight: bold;
}

.NotesBox {
  text-align: left;
  font-size: small;
}

img {
  max-width: 100%;
}

a:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE;IACE,wBAAwB;GACzB,8BAA8B;EAC/B;EACA;IACE,4BAA4B;IAC5B,aAAa;EACf;AACF;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;;AAGA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".App {\n  text-align: center;\n  background-color: #282c34;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content:flex-start;\n  font-size: calc(8px + 2vmin);\n  color: white;\n  max-width: 100%;\n  min-height: 100vh;\n  padding-left: 1vw;\n  padding-right: 1vw;\n}\n\n.App h3 {\n  margin-bottom: -1em;\n}\n\n.App-header {\n  /* text-align: center; */\n  background-color: #282c34;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  font-size: calc(8px + 2vmin);\n  color: white;\n  width: 100%;\n  height: 8vh;\n  border-bottom: 1px solid rgb(29, 29, 29);\n}\n\n@keyframes myAnimation{\n  35%{\n    transform: translateY(0);\n   /* transform: rotateX(0deg); */\n  }\n  100%{\n    transform: translateY(-90vh);\n    display: none;\n  }\n}\n\n.App-Modal{\n    animation-name: myAnimation;\n    animation-duration: 4000ms;\n    animation-fill-mode: forwards;\n}\n\n.App-Modal {\n  background-color: transparent;\n  min-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n\n@keyframes myAnimationViz{\n  50%{\n    transform: translateY(0vh);\n  }\n  100%{\n    transform: translateY(-90vh);\n  }\n}\n\n.FirstViz {\n  animation-name: myAnimationViz;\n  animation-duration: 4000ms;\n  animation-fill-mode: backwards;\n  margin-bottom: 7vh;\n}\n\n.FirstViz img {\n  max-width: 80%;\n  max-height: 80%;\n}\n\n.SideBySide {\n  display: flex;\n  /* flex-direction: row; */\n  justify-content: space-evenly;\n  gap: 5vw;\n  margin-bottom: 5vh;\n}\n\n.SideBySide img {\n  width: 35vw;\n  height: 40vh;\n}\n\n.TextBox {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n}\n\n.TextBox a {\n  color: white;\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.NotesBox a {\n  color: white;\n  text-decoration: none;\n}\n\n.App-header a {\n  color: white;\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.NotesBox {\n  text-align: left;\n  font-size: small;\n}\n\nimg {\n  max-width: 100%;\n}\n\na:hover {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
